export class Produtor {
  constructor ({
    id,
    cpf,
    cnpj,
    inscricao_estadual,
    rg,
    nome,
    nome_fantasia,
    razao_social,
    email,
    data_nascimento,
    sexo,
    telefones,
    pais,
    estado,
    cidade,
    bairro,
    numero,
    logradouro,
    cep,
    complemento,
    fazendas,
    contas,
  } = {
    id: '',
    cpf: '',
    cnpj: '',
    inscricao_estadual: '',
    rg: '',
    nome: '',
    nome_fantasia: '',
    razao_social: '',
    email: '',
    data_nascimento: '',
    sexo: '',
    telefones: [],
    pais: '',
    estado: '',
    cidade: '',
    bairro: '',
    numero: '',
    logradouro: '',
    cep: '',
    complemento: '',
    fazendas: [],
    contas: [],
  }) {
    this.id = id
    this.cpf = cpf
    this.cnpj = cnpj
    this.inscricao_estadual = inscricao_estadual
    this.rg = rg
    this.nome = nome
    this.nome_fantasia = nome_fantasia
    this.razao_social = razao_social
    this.email = email
    this.data_nascimento = data_nascimento
    this.sexo = sexo
    this.telefones = telefones
    this.pais = pais
    this.estado = estado
    this.cidade = cidade
    this.bairro = bairro
    this.numero = numero
    this.logradouro = logradouro
    this.cep = cep
    this.complemento = complemento
    this.fazendas = fazendas
    this.contas = contas || []
  }
}

export function createProdutor (data) {
  return Object.freeze(new Produtor(data))
}
